export default "__VITE_ASSET__B0eLxdSR__"